export class Events {
  constructor() {
    const events = document.querySelectorAll('.js-event');
    for (const event of events) {
      if (event.dataset.date) {
        // The date is assumed to take the form of dayOfWeek day month year HH(am|pm)-HH(am|pm)
        const parts = event.dataset.date.split(' ').filter(part => part !== "").map(part => part.trim());
        const date = new Date(parts.slice(0, 4));

        if (isNaN(date)) {
          event.dateset.date = "0";
          continue;
        }

        const startTime = parts[parts.length - 1].split('-')[0].slice(0, -2);
        const [hour, minute] = startTime.split(':').map(part => Number(part));
        const isPm = parts[parts.length - 1].split('-')[0].slice(-2).toLowerCase() == "pm";

        if (hour) {
          date.setHours((isPm && hour !== 12) ? hour + 12 : hour);
          if (minute) {
            date.setMinutes(minute)
          }
        }
        
        event.dataset.date = Math.floor(date.getTime() / 1000)
      }
    }

    const sortedEvents = Array.from(events).sort((a, b) => {
      // Show events with no date last
      if (b.dataset.date == '0') {
        return -1;
      } else if (a.dataset.date == '0') {
        return 1;
      } else if (Number(b.dataset.date) < Number(a.dataset.date)) {
        return 1;
      } else if (Number(b.dataset.date) > Number(a.dataset.date)) {
        return -1;
      }
      return 0;
    });

    const eventList = document.querySelector('.js-eventsList');
    if (eventList) {
      eventList.innerHTML = "";
      sortedEvents.forEach(eventDiv => eventList.appendChild(eventDiv));
      eventList.classList.remove('u-hidden');
    }
  }
}
